import * as Sentry from "@sentry/react";

import { setNativeClientBuildInfo, type NativeClientBuildInfoInput } from "./client-build-info";
import { getOpenPanelClientForJungleWebApp } from "./openpanel-client";

export function applyNativeClientBuildInfoToTelemetry(input: NativeClientBuildInfoInput): void {
  const clientBuildInfo = setNativeClientBuildInfo(input);

  try {
    getOpenPanelClientForJungleWebApp().setGlobalProperties(clientBuildInfo);
  } catch {
    // Telemetry enrichment must never affect the native bridge.
  }

  try {
    Sentry.setTags(clientBuildInfo);
  } catch {
    // Sentry may be disabled in development or missing configuration.
  }
}
